module.exports = __webpack_public_path__ + "img/my-profile.767558c1.svg";